import { Injectable } from '@angular/core';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable()
export class PasswordService {
  // userid: any;
  url = environment.configURI;
  constructor(private httpClient: HttpClient, private userFriendlyMsgs: UserFriendlyMsgs) { }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit() {
  }
  sendEmail(email) {
    const body = {
      'email_id' : email.toLowerCase(),
    };
    return this.httpClient.post(this.url + '/forgotpassword/', body).catch(this.userFriendlyMsgs.errorHandler);
  }

  changePassword(passwordData, userid) {
    return this.httpClient.post(this.url + '/changepassword?userid=' + userid, passwordData)
      .catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/password/password.service.ts